// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabbar-toggler[data-v-38cabcdf]{min-width:37px;min-height:37px}.tabbar-toggler__block[data-v-38cabcdf]{display:flex;width:100%;height:100%}.tabbar-toggler__logo[data-v-38cabcdf]{height:36px;padding:4px}", ""]);
// Exports
module.exports = exports;
